module.exports = __webpack_public_path__ + "img/giveUp.8dc41993.png";